import bgHeader from './bg/bg-head.png'
import cartaNatal from './img/cartaNatal.png'
import singosBG from './bg/signosBg.png'
import revolucionSolar from './img/revolucionSolar.png'
import encuentrosProfundos from './img/encuentrosProfundos.png'
import cartaDracon from './img/cartaDracon.png'
import transito from './img/transito.png'
//signos
import acuario from './img/signos/acuario.png'
import aries from './img/signos/aries.png'
import cancer from './img/signos/cancer.png'
import capricornio from './img/signos/capricornio.png'
import escorpion from './img/signos/escorpion.png'
import geminis from './img/signos/geminis.png'
import leo from './img/signos/leo.png'
import libra from './img/signos/libra.png'
import piscis from './img/signos/piscis.png'
import sagitario from './img/signos/sagitario.png'
import tauro from './img/signos/taurus.png'
import virgo from './img/signos/virgo.png'
import h1Logo from './bg/h1Logo.png'

export const imagenesAll = {
  h1Logo,
  bgHeader,
  cartaNatal,
  revolucionSolar,
  encuentrosProfundos,
  cartaDracon,
  transito,
  singosBG,
  acuario,
  aries,
  cancer,
  capricornio,
  escorpion,
  geminis,
  leo,
  libra,
  piscis,
  sagitario,
  tauro,
  virgo
}